module.exports = __webpack_public_path__ + "img/21.3a04beeb.webp";